'use client';

import BearBackground from '@/components/bear-background/';
import DAppsView from '@/sections/dapps';

export default function Dapps() {
  return (
    <BearBackground type='dapps'>
      <DAppsView />
    </BearBackground>
  );
}
